/**
 * @fileoverview added by tsickle
 * Generated from: custom-component/custom-tags.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Injectable } from '@angular/core';
import * as ɵngcc0 from '@angular/core';
var CustomTagsService = /** @class */ (function () {
    function CustomTagsService() {
        this.tags = [];
    }
    /**
     * @param {?} tag
     * @return {?}
     */
    CustomTagsService.prototype.addCustomTag = /**
     * @param {?} tag
     * @return {?}
     */
    function (tag) {
        this.tags.push(tag);
    };
CustomTagsService.ɵfac = function CustomTagsService_Factory(t) { return new (t || CustomTagsService)(); };
CustomTagsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CustomTagsService, factory: function (t) { return CustomTagsService.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CustomTagsService, [{
        type: Injectable
    }], function () { return []; }, null); })();
    return CustomTagsService;
}());
export { CustomTagsService };
if (false) {
    /** @type {?} */
    CustomTagsService.prototype.tags;
}

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3VzdG9tLXRhZ3Muc2VydmljZS5qcyIsInNvdXJjZXMiOlsiY3VzdG9tLXRhZ3Muc2VydmljZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7OztnREFHTTtBQUNOO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBAZmlsZW92ZXJ2aWV3IGFkZGVkIGJ5IHRzaWNrbGVcbiAqIEdlbmVyYXRlZCBmcm9tOiBjdXN0b20tY29tcG9uZW50L2N1c3RvbS10YWdzLnNlcnZpY2UudHNcbiAqIEBzdXBwcmVzcyB7Y2hlY2tUeXBlcyxjb25zdGFudFByb3BlcnR5LGV4dHJhUmVxdWlyZSxtaXNzaW5nT3ZlcnJpZGUsbWlzc2luZ1JldHVybix1bnVzZWRQcml2YXRlTWVtYmVycyx1c2VsZXNzQ29kZX0gY2hlY2tlZCBieSB0c2NcbiAqL1xuaW1wb3J0IHsgSW5qZWN0YWJsZSB9IGZyb20gJ0Bhbmd1bGFyL2NvcmUnO1xudmFyIEN1c3RvbVRhZ3NTZXJ2aWNlID0gLyoqIEBjbGFzcyAqLyAoZnVuY3Rpb24gKCkge1xuICAgIGZ1bmN0aW9uIEN1c3RvbVRhZ3NTZXJ2aWNlKCkge1xuICAgICAgICB0aGlzLnRhZ3MgPSBbXTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQHBhcmFtIHs/fSB0YWdcbiAgICAgKiBAcmV0dXJuIHs/fVxuICAgICAqL1xuICAgIEN1c3RvbVRhZ3NTZXJ2aWNlLnByb3RvdHlwZS5hZGRDdXN0b21UYWcgPSAvKipcbiAgICAgKiBAcGFyYW0gez99IHRhZ1xuICAgICAqIEByZXR1cm4gez99XG4gICAgICovXG4gICAgZnVuY3Rpb24gKHRhZykge1xuICAgICAgICB0aGlzLnRhZ3MucHVzaCh0YWcpO1xuICAgIH07XG4gICAgQ3VzdG9tVGFnc1NlcnZpY2UuZGVjb3JhdG9ycyA9IFtcbiAgICAgICAgeyB0eXBlOiBJbmplY3RhYmxlIH0sXG4gICAgXTtcbiAgICByZXR1cm4gQ3VzdG9tVGFnc1NlcnZpY2U7XG59KCkpO1xuZXhwb3J0IHsgQ3VzdG9tVGFnc1NlcnZpY2UgfTtcbmlmIChmYWxzZSkge1xuICAgIC8qKiBAdHlwZSB7P30gKi9cbiAgICBDdXN0b21UYWdzU2VydmljZS5wcm90b3R5cGUudGFncztcbn1cbiJdfQ==